'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { pageView } from 'utils/googleAnalyticsHelper'

export default function AnalyticsPageViews() {
  const pathname = usePathname()
  const search = useSearchParams().toString()

  useEffect(() => {
    pageView({ path: pathname })
  }, [pathname, search])

  // Re-send the page view once analytical consent is granted so the visit is recorded with cookies
  useEffect(() => {
    const handleConsentChange = (e: Event) => {
      if ((e as CustomEvent).detail?.analytical) {
        pageView({ path: window.location.pathname })
      }
    }

    window.addEventListener('cookie-consent-change', handleConsentChange)

    return () => window.removeEventListener('cookie-consent-change', handleConsentChange)
  }, [])

  return null
}
